
  import { defineComponent } from 'vue';

  interface QuestionNotesProps {
    notes: string;
  }

  export default defineComponent<QuestionNotesProps>({
    props: ['notes'],
  });
